export default "__VITE_ASSET__3bdbaa75__"